import React, { Component } from "react";
import ReactDOM from "react-dom/client";
import Container from "./Container";
import constant from "./constant.js";
import "./i18n";
let timer = null;
function checkAxiomAPIs() {
  if (typeof AxiomAPIs != "undefined") {
    clearInterval(timer);
    AxiomAPIs.registerApp("HawkeyeV2", renderReact, false, "React", constant.appArray);
  }
}

function renderReact(element, props) {
  const appRoot = ReactDOM.createRoot(element);
  appRoot.render(
    <Container
      appName={props.appName}
      appID={props.appID}
      backgroundColor={props.backgroundColor}
      client={props.client}
    />
  );
}

timer = setInterval(checkAxiomAPIs, 100);
